import SwiperSlider from '../base';

const selectors = {
  sliderEl: '[data-comp-photo-carousel]',
};

const swiperOptions = {
  slidesPerView: 'auto',
  autoplay: {
    delay: 1,
  },
  observer: true,
  observeSlideChildren: true,
  speed: 30000,
  slidesPerGroup: 5,
  loop: true,
  loopedSlides: 5,
  freeMode: true,
};

export default class SectionPhotoCarousel extends SwiperSlider {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.sources = this.$container.querySelectorAll('source[data-srcset]');
    this.sourcesCount = this.sources.length;
    this.sourcesLoaded = 0;

    // -----------------------------------------------------------------------
    // Temporary fix below (bypassing mutation observer stuffsw)
    // -----------------------------------------------------------------------

    // this.boundMutationHnalder = this.mutationHandler.bind(this);
    // this.mutationObserver = new MutationObserver(this.boundMutationHnalder);

    /*
    this.$container.querySelectorAll('source[data-srcset]').forEach(el => {
      this.observeMutation(el);
    });
    */
    this.loadCarousel(); // Remove this when reverting temporary fix

    // -----------------------------------------------------------------------
    // End of temporary fix
    // -----------------------------------------------------------------------
  }

  /* Initialize the carousel AFTER all the photos have loaded.
   * Swiper will clone each slide. If we update the slide when lazy-loading images,
   * The cloned slides will still be using the fallback image.
   */
  mutationHandler([mutationsList]) {
    if (mutationsList.type !== 'attributes' && mutationsList.attributeName !== 'data-srcset') return;
    this.sourcesLoaded += 1;
    if (this.sourcesLoaded === this.sourcesCount) this.loadCarousel();
  }

  loadCarousel() {
    this.photoCarousel = new this.Swiper(
      this.$container,
      swiperOptions,
    );
  }

  observeMutation(el) {
    this.mutationObserver.observe(el, { attributes: true });
  }
}
